import React from "react";
import LinkButton from "../common/linkButton";
import "./card.css";

export const Card = ({
  imgSource,
  imgAlt,
  title,
  title2,
  text,
  bgColor,
  colorText,
  startText,
  startLink,
  startColor,
  startText2,
  startColor2,
  disabled = false, // New prop to control button state
  prefix,
}) => {
  return (
    <div className="col-lg-4" style={{ height: "100%" }}>
      <div
        className="card card-addition "
        style={{
          height: "100%",
          border: "0px",
          backgroundColor: bgColor,
          color: colorText,
        }}
      >
        <div className="card-bg "></div>
        <img
          className="card-img-top"
          src={`/Images/${imgSource}`}
          alt={imgAlt}
          style={{ height: "225px", objectFit: "cover", pointerEvents: "none" }}
        />
        <div className="card-body d-flex flex-column">
          <h5 className="card-title">
            {title
              .replace("standard", "")
              .replace("Standard", "")
              .replace("  ", " ")
              .trim()}
          </h5>
          <p className="card-text">{text}</p>
          <LinkButton
            className="btn btn-lg btn-block btn-secondary mt-auto"
            style={{
              backgroundColor: disabled ? "#ccc" : startColor,
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.6 : 1,
            }}
            to="/proposals/step-guide"
            disabled={disabled}
            onClick={() => {
              if (!disabled) {
                startLink(
                  String(
                    title === "Elements" || title === "ProSelect™"
                      ? `${title} - ${startText}`
                      : title
                  )
                );
              }
            }}
          >
            {disabled ? "Loading..." : startText ? startText : "Start"}
          </LinkButton>
          {title2 != null &&
            title2.split(";").map((element) => {
              let buttonText = element.trim();

              // Handle multiple prefixes separated by ";"
              if (prefix) {
                const prefixList = prefix.split(";").map((p) => p.trim());

                // Try to remove each prefix from the button text
                for (const prefixItem of prefixList) {
                  if (prefixItem && buttonText.startsWith(prefixItem)) {
                    buttonText = buttonText.substring(prefixItem.length).trim();
                    break; // Stop after first match
                  }
                }
              }

              return (
                <LinkButton
                  key={"card-" + element}
                  className="btn btn-lg btn-block btn-secondary"
                  style={{
                    backgroundColor: disabled ? "#ccc" : startColor2,
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.6 : 1,
                  }}
                  to="/proposals/step-guide"
                  disabled={disabled}
                  onClick={() => {
                    if (!disabled) {
                      startLink(String(element.trim()));
                    }
                  }}
                >
                  {disabled ? "Loading..." : buttonText.trim()}
                </LinkButton>
              );
            })}
        </div>
      </div>
    </div>
  );
};
